// extracted by mini-css-extract-plugin
export default {"footerElem":"footer_footerElem__lhw6R","footerLink":"footer_footerLink__Qy7DO"};